import React from 'react';
import { Mic } from 'lucide-react';

const Footer = ({ variant = 'default' }) => {
  const footerStyles = {
    background: 'linear-gradient(135deg, var(--accent-brown) 0%, var(--accent-primary) 100%)',
    borderTop: 'none',
    padding: '3rem 0',
    marginTop: 'auto'
  };

  const containerStyles = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 2rem'
  };

  const footerContentStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '2rem'
  };

  const logoStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  };

  const logoIconStyles = {
    width: '24px',
    height: '24px',
    background: 'rgba(255, 255, 255, 0.9)',
    color: 'var(--accent-brown)',
    borderRadius: '6px',
    padding: '4px'
  };

  const logoTextStyles = {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: 'white'
  };

  const footerTextStyles = {
    color: 'rgba(255, 255, 255, 0.8)',
    fontSize: '0.875rem',
    margin: 0
  };

  return (
    <footer style={footerStyles}>
      <div style={containerStyles}>
        {/* Badges Section - Centered */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '1.5rem',
          flexWrap: 'wrap',
          marginBottom: '1.5rem',
          paddingBottom: '1.5rem',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <a href="https://twelve.tools" target="_blank" rel="noopener">
            <img src="https://twelve.tools/badge0-dark.svg" alt="Featured on Twelve Tools" width="200" height="54" />
          </a>
          <a href="https://auraplusplus.com/projects/conviviality" target="_blank" rel="noopener">
            <img src="https://auraplusplus.com/images/badges/featured-on-dark.svg" alt="Featured on Aura++" />
          </a>
          <a href="https://dofollow.tools" target="_blank" rel="noopener">
            <img src="https://dofollow.tools/badge/badge_dark.svg" alt="Featured on Dofollow.Tools" width="200" height="54" />
          </a>
          <a href="https://startupfa.me/s/conviviality?utm_source=conviviality.ai" target="_blank" rel="noopener">
            <img src="https://startupfa.me/badges/featured/dark.webp" alt="Conviviality - Featured on Startup Fame" width="171" height="54" />
          </a>
        </div>

        <div style={footerContentStyles}>
          <div style={logoStyles}>
            <div style={logoIconStyles}>
              <Mic size={16} />
            </div>
            <span style={logoTextStyles}>Conviviality</span>
          </div>
          <div>
            <p style={footerTextStyles}>
              © 2025 Physinomos, Inc. All rights reserved.
            </p>
            <p style={{ ...footerTextStyles, marginTop: '0.5rem' }}>
              <a href="mailto:support@conviviality.ai" style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none' }}>support@conviviality.ai</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;